import { defineMessages } from 'react-intl'

/**
 * High-frequency cross-vertical CTAs and recovery links — `docs/product-taxonomy.md` §15.
 * Prefer these over retyping the same `defaultMessage` in offer, order, and cancellation flows.
 */
const commonMessages = defineMessages({
  browseAllHotelOffers: {
    id: 'rY7YWkfRXds97SZoD7yj',
    defaultMessage: 'Browse all hotel offers',
  },
  browseAllCruiseOffers: {
    id: 'fmoni6H9-d0M4c-6Xcuy',
    defaultMessage: 'Browse all cruise offers',
  },
  browseAllExperiences: {
    id: 'w54uY2Z1A3WYA6q2GZrq',
    defaultMessage: 'Browse all experiences',
  },
  browseYourFavouriteEscapes: {
    defaultMessage: 'Browse your favourite escapes',
    id: 'D_NWPBTcYv84ZbD7SZ3a',
  },
  viewBundleOffer: {
    defaultMessage: 'View bundle offer',
    id: 'KUDq4NZH1t22KubLWkaq',
  },
  viewVoucher: {
    id: '4DN24eqpJaloIsiXwotg',
    defaultMessage: 'View voucher',
  },
  viewVouchers: {
    id: 'lBxzx9OIxRxuEghkdrce',
    defaultMessage: 'View vouchers',
  },
  viewTicketVoucher: {
    id: 'rFN-dY9Kx5SZJSyAHSnA',
    defaultMessage: 'View ticket voucher',
  },
  viewTicketVouchers: {
    id: 'DTUFgi9ZmnRjdu0pV8Oy',
    defaultMessage: 'View ticket vouchers',
  },
  changeFlight: {
    id: 'UF8AvylAPag2IbfiKdoW',
    defaultMessage: 'Change flight',
  },
  addFlights: {
    id: 'aINrX7JfIZ78xp-sCui6',
    defaultMessage: 'Add flights',
  },
  returnToMyEscapes: {
    id: 'miLg2wrMGuITe0x00irA',
    defaultMessage: 'Return to My Escapes',
  },
  sendToAgent: {
    id: 'P8qHRO8gkwya796q-SlG',
    defaultMessage: 'Send to agent',
  },
})

export default commonMessages
